import React, { useEffect, useState } from "react";
import { Avatar, Button, CustomTag, InfoCardNewAdv, StatusTags } from "../../../components";
import AddClient from "./AddClient";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearClientProfile,
  getClientOneStart,
} from "../../../redux/slices/client/clientSlice";
import axiosRequest from "../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../redux/apiConfig";
const ClientDetails = () => {
  const [isEditable, setIsEditable] = useState(false);
  const [clientInfo, setClientInfo] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  const { code: uiid } = state ? state : {};
  const currentClient = useSelector(
    (state) => state.client.currentClient.clientDetails
  );
  const clientProfileUiid = useSelector(
    (state) => state.client.clientProfileUiid
  );
  useEffect(() => {
    try {
      if (uiid) {
        if (clientProfileUiid) {
          dispatch(clearClientProfile());
        }
        dispatch(
          getClientOneStart({
            clientUiid: uiid,
            retrieve: `businessName roleContacts phone generalInfo.invoiceLocation uiid email federalId contact website recordStatus ownership shortCode`,
            //
            ref: "PlacementWithEmp",
            incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.jobCode",
          })
        );
        const fetchClientInfo = async () => {
          const allClientsActive = await axiosRequest({
            method: "GET",
            url: ENDPOINTS.CLIENTS.GET_BY_UIID,
            params: {
              coll: "Client",
              ret: "placements",
              ref: "PlacementWithEmp",
              incl: "employeeId jobInfo.startDate jobInfo.endDate status",
              fil: JSON.stringify({ uiid: { type: "NONE", value: uiid } }),
            },
          });
          const allPlacements = await axiosRequest({
            method: "GET",
            url: ENDPOINTS.PLACEMENTS.GET_ALL,
            params: {
              coll: "Placement",
              ret: "employeeId",
              fil: JSON.stringify({
                "jobInfo.billClient": { type: "NONE", value: uiid },
              }),
            },
          });
          let activePlacements = allClientsActive?.data?.data?.placements;
          activePlacements = Array.from(
            new Map(
              activePlacements
                ?.filter((item) => {
                  const endDate = item?.jobInfo?.endDate
                    ? new Date(item.jobInfo.endDate)
                    : null;
                  return (
                    item?.jobInfo?.status !== 2 &&
                    (!endDate || endDate >= new Date())
                  );
                })
                .map((item) => [item.employeeId.uiid, item])
            ).values()
          );
          let allConsultants = allPlacements?.data?.data || [];
          setClientInfo({
            consultantsWorked:
              new Set(allConsultants?.map((item) => item?.employeeId)).size ||
              0,
            activeConsultants: activePlacements?.length || 0,
          });
        };
        fetchClientInfo();
      }
    } catch (error) {
      console.log("error", error);
    }
    // return () => {
    //   dispatch(clearClientProfile());
    // }
  }, [uiid]);
  const handleToggleEdit = () => {
    setIsEditable(!isEditable);
  };
  return (
    <div className="mt-3 flex flex-col gap-2 ">
      <div className="flex flex-col-reverse xl:flex-row gap-3">
        <div className="flex items-center gap-2 flex-1">
          <div>
            <Avatar size="xxl" alt={"Zodiac Solutions Inc"} />
          </div>
          <div className="flex flex-col justify-between gap-1 flex-1 ">
            <div className="flex gap-2 items-center">
              <h6 className="subtitle-reg">{currentClient?.businessName}</h6>
              <StatusTags
                tag={currentClient?.recordStatus === 1 ? "Active" : "Inactive"}
                icon
              />
            </div>
            <div className="flex gap-2 items-center">
              <span className="body-two text-neutrals">
                {[
                  currentClient?.generalInfo?.invoiceLocation?.city,
                  currentClient?.generalInfo?.invoiceLocation?.state,
                  currentClient?.generalInfo?.invoiceLocation?.country,
                ]
                  .filter(Boolean)
                  .join(", ")}
              </span>
            </div>
          </div>

          <div className="flex gap-3 flex-1">
            {/* <div>tags1</div> */}
            {/* <div>
              <CustomTag
                // count={"75"}
                count={clientInfo?.consultantsWorked || "0"}
                description={"Consultant Worked"}
                icon={"directions_run"}
                color={"info"}
                size={"sm"}
              />
            </div> */}
            <div>
              <InfoCardNewAdv
                layout="option6"
                value={clientInfo?.consultantsWorked || "0"}
                title={"Consultant Worked"}
                icon={"directions_run"}
                iconConfig={{className:"text-[24px]! text-black!"}}
                valueConfig={{className:"text-black! ml-[16px]!"}}
                titleConfig={{className:"text-black! font-semibold!"}}
                bgConfig={{className:"bg-info-50!"}}
              />
            </div>
            {/* <div>tag2</div> */}
            {/* <div>
              <CustomTag
                // count={"98"}
                count={clientInfo?.activeConsultants || "0"}
                description={"Active Consultants"}
                icon={"hail"}
                color="success"
                size={"sm"}
              />
            </div> */}
            <div>
              <InfoCardNewAdv
                layout="option6"
                value={clientInfo?.activeConsultants || "0"}
                title={"Active Consultants"}
                icon={"hail"}
                iconConfig={{className:"text-[24px]! text-success!"}}
                valueConfig={{className:"text-success! ml-[16px]!"}}
                titleConfig={{className:"text-success!"}}
                bgConfig={{className:"bg-success-50!"}}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-3 flex-1 justify-end">
          <div>
            <Button
              type="button"
              title={"Back"}
              icon={"arrow_left_alt"}
              size={"sm"}
              onClick={() => navigate("/client")}
            />
          </div>
          <div>
            {/* <Button
              type="button"
              title={"Edit"}
              size={"sm"}
              icon={"edit_square"}
            /> */}

            {!isEditable && (
              <Button
                type="button"
                title={"Edit"}
                size={"sm"}
                icon={"edit_square"}
                onClick={() => handleToggleEdit()}
              />
            )}
          </div>
        </div>
      </div>
      <div className="mt-2">
        <AddClient
          isEditable={isEditable}
          setIsEditable={setIsEditable}
          clientId={uiid}
        />
      </div>
    </div>
  );
};

export default ClientDetails;
